import type { NavigationGuardNext, RouteLocationNormalized } from "vue-router"
import { useAuthStore } from "@core/stores/auth.store"

/**
 * Garde route dashboard optimisation contractuelle (parc) : alignement menu header
 * (`hasModuleOptimTurpeDashboard` + `isEmployeWriteOrHigher`).
 */
export async function beforeEnterDashboardOptimTurpe(
    _to: RouteLocationNormalized,
    _from: RouteLocationNormalized,
    next: NavigationGuardNext
): Promise<void> {
    const authStore = useAuthStore()
    if (authStore.isLogged && !authStore.userId) {
        await authStore.fetchUser()
    }
    if (
        authStore.hasModuleOptimTurpeDashboard &&
        authStore.isEmployeWriteOrHigher
    ) {
        next()
    } else {
        next({ name: "PageHomeBuildings" })
    }
}
